'use client';

import type { Locale } from '@core/Entities/Locale/Locale.entity';
import type { LocationAttrs } from '@core/Entities/Location/LocationAttr.entity';
import { Button } from '@gds/Button/Button';
import { Email } from '@gds/Icons/Paths/Email';
import { Typography } from '@gds/Typography/Typography';

import type { PlpFiltersMessagesProps } from '../Filters/FilterPanel.entity';
import { useSavedSearchForm } from './UseSavedSearchForm';

import styles from './SavedSearchForm.module.css';

interface SavedSearchPageCtaProps {
  locale: Locale;
  strings: PlpFiltersMessagesProps;
  locationAttrs?: LocationAttrs;
}

export const SavedSearchPageCta = ({ locale, strings, locationAttrs }: SavedSearchPageCtaProps) => {
  const { openForm, canUseSavedSearch } = useSavedSearchForm({
    locale,
    strings,
    locationAttrs,
  });
  const isButtonPrimary = false;

  if (!canUseSavedSearch) return null;

  return (
    <div className={styles.pageCtaWrapper}>
      <Typography Component={'h2'} variant={'h4'}>
        {strings.cantFind}
      </Typography>
      <Typography variant={'subheading4'}>{strings.createPersonalisedAlert}</Typography>
      <Button
        leftIcon={<Email />}
        {...(isButtonPrimary && { color: 'primary' })}
        {...(!isButtonPrimary && { variant: 'outlined' })}
        onClick={openForm}
      >
        {strings.createAlert}
      </Button>
    </div>
  );
};

SavedSearchPageCta.displayName = 'SavedSearchPageCta';
